<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3 bg-light">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <span>Casi clinici</span>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Lista</li>
        </ol>
      </div>
    </nav>
    <div class="container">
      <LoadedComponent :loading="loading" />
      <div class="pt-2 pl-2 mb-4 text-center" v-if="!loading">
        <router-link to="/casi-clinici/nuovo-caso-clinico" class="btn btn-primary custom-primary">Aggiungi caso
          clinico</router-link>

        <router-link to="/casi-clinici/bozze" class="btn btn-primary ml-2">Bozze</router-link>
        <button type="button" class="btn btn-primary ml-2" @click="loadAllActivity" v-if="allcases == false">
          Tutti i casi
        </button>
        <button type="button" class="btn btn-primary ml-2" @click="loadActivity" v-else>
          Casi filtrati per le tue preferenze
        </button>
      </div>
      <div></div>

      <div class="col-sm-12 mt-4" v-if="!loading">
        <div class="mb-2">
          <AlertComponent :message="successMessage" :alert-type="'success'" />
        </div>
        <div class="mb-2">
          <AlertComponent :message="errorMessage" :alert-type="'danger'" />
        </div>

        <div class="row">
          <FilterComponent :activities="originalActivities" @setActivities="setActivities" :patologies="patologies"
            :categoryMedicals="categoryMedicals" :anatomicalDistricts="anatomicalDistricts"
            v-on:update:filteredText="updateText" v-on:update:filteredPatologies="updatePatologies"
            v-on:update:filteredCategoryMedicals="updateCategoryMedicals"
            v-on:update:filteredAnatomicalDistricts="updateAnatomicalDistricts" category="1" :permission="true">
          </FilterComponent>
          <div class="col-lg-9" v-if="activities.length > 0">
            <article v-for="(clinicalCase, index) in activities" :key="index" :class="clinicalCase.class" class="card ">
              <div class="row align-items-center p-4">
                <div class="col-md-7">
                  <router-link :to="'/casi-clinici/show/' + clinicalCase.slug" :class="'read-more open_page' + clinicalCase.shows == true
                    ? ''
                    : 'disabled'
                    ">
                    <div class="alert alert-success d-none">
                      <h5 class="cipriani-status-message" v-if="clinicalCase.shows == true">
                        Questo caso clinico è un corso formativo a numero chiuso.
                      </h5>
                    </div>

                    <div class="entry-body">
                      <div class="entry-meta">
                        <span class="entry-author" v-if="clinicalCase.anonymous">Caso anonimo</span>
                        <span class="entry-author" v-if="!clinicalCase.anonymous">{{ clinicalCase.full_name }}</span>
                        <span class="meta-separator">|</span>
                        <span>{{
                          clinicalCase.publish_date
                          }}</span>

                        <span class="meta-separator">|</span>
                        <span>{{
                          clinicalCase.hospital
                          }}</span>
                      </div>

                      <h2 class="entry-title">
                        <span class="open_page">{{
                          clinicalCase.name
                          }}</span>
                      </h2>

                      <div class="entry-cats">
                        <span>{{
                          clinicalCase.category_medical
                          }}</span>
                      </div>
                      <!-- End .entry-cats -->
                      <!-- End .entry-title -->


                      <!-- End .entry-content -->
                    </div>
                  </router-link>
                </div>
                <div class="col-md-5 d-flex justify-content-center">
                  <img v-if="clinicalCase?.cover" :src="clinicalCase?.cover?.path" class="img-fluid" alt="image desc" />
                  <!-- -->
                  <img v-else
                    src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg"
                    class="img-fluid" alt="image desc" />

                  <!-- End .entry-media -->
                </div>
              </div>
            </article>
            <hr />
            <div>
              <ul class="pagination">
                <li class="page-item" v-if="currentPage > 1" @click="goToPage(currentPage - 1)">
                  <span class="page-link"> href="#">Indietro</span>
                </li>
                <li class="page-item" v-for="page in pages" :key="page" @click="goToPage(page)">
                  <span class="page-link" :class="{ active: currentPage === page }">{{ page }}</span>
                </li>
                <li class="page-item" v-if="currentPage < numberOfPages" @click="goToPage(currentPage + 1)">
                  <span class="page-link">Avanti</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-9" v-else>
            <p>Nessun risultato</p>
          </div>

          <!-- End .col-lg-3 -->

          <!-- End .col-md-5 -->
        </div>
      </div>
    </div>
    <!-- End .container -->
    >
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import FilterComponent from "@/components/FilterComponent.vue";
import httpservices from "@/services/httpservices.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "ClinicalCasePage",
  props: {},
  components: {
    LoadedComponent,
    AlertComponent,
    FilterComponent,
  },
  setup() {
    const auth = useAuth();
    return auth;
  },
  data() {
    return {
      activities: [],
      originalActivities: [],
      loading: true,
      successMessage: "",
      allcases: false,
      itemsPerPage: 5,
      errorMessage: "",
      currentPage: 1,
      patologies: [],
      categoryMedicals: [],
      anatomicalDistricts: [],
      filteredPatologies: [],
      filteredCategoryMedicals: [],
      filteredAnatomicalDistricts: [],
      pages: [],
      query: {
        patologies: [],
        text: "",
        category_medical: [],
        anatomical_district: [],
      },
    };
  },
  mounted() { },
  created() { },
  methods: {
    setActivities(value) {
      this.activities = value;
    },
    setQueryParams(paramsObject) {
      const queryParams = new URLSearchParams();

      // Aggiungi ogni coppia di parametri-valore all'oggetto URLSearchParams

      for (const key in paramsObject)
      {
        if (Object.prototype.hasOwnProperty.call(paramsObject, key))
        {
          const values = paramsObject[key];

          values.forEach((value) => {
            queryParams.append(key, value);
          });
        }
      }

      // Ottieni l'URL corrente
      const currentUrl = new URL(window.location.href);

      // Aggiungi i parametri di query all'URL
      currentUrl.search = queryParams.toString();

      // Restituisci il nuovo URL con i parametri di query aggiunti
      return currentUrl.toString();
    },
    buildQueryString(queryObject) {
      let queryString = "";
      for (const key in queryObject)
      {
        if (Array.isArray(queryObject[key]))
        {
          queryObject[key].forEach((value) => {
            queryString += `${key}[]=${value}&`;
          });
        } else
        {
          queryString += `${key}=${queryObject[key]}&`;
        }
      }
      // Rimuovi l'ultimo carattere "&" che potrebbe essere rimasto
      queryString = queryString.slice(0, -1);
      return queryString ? `?${queryString}` : "";
    },
    async search() {
      //this.loading = true;

      const params = { params: this.query };
      var searchUrl = this.buildQueryString(this.query);
      const newPath = window.location.pathname + searchUrl;

      // Aggiorna il percorso URL senza ricaricare la pagina
      window.history.pushState({}, "", newPath);

      await httpauth
        .get("/casi-clinici/search-paginate", params)
        .then((response) => {
          var data = response.data.data;
          this.activities = data.map((oggetto) => {
            const companyId = oggetto.company_id;
            const classe =
              companyId === null
                ? "entry entry-list mb-2 mb-md-3 p-2 height-article"
                : "entry entry-list mb-2 mb-md-3 bg-light border border-2  border-danger rounded p-2 height-article";
            return { ...oggetto, class: classe };
          });

          for (var i = 1; i < response.data.meta.last_page; i++)
          {
            this.pages.push(i);
          }
          this.loading = false;

          //this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    goToPage(page) {
      this.currentPage = page;
      const original = this.originalActivities;
      let start = (this.currentPage - 1) * this.itemsPerPage;
      this.activities = original.slice(start, start + this.itemsPerPage);
    },
    async updateText(searchText) {
      this.loading = true;
      this.query.text = searchText;
      this.search();
    },
    async updatePatologies(selectedCategories) {
      this.loading = true;
      console.log(selectedCategories);
      this.query.patologies = selectedCategories;

      this.search();
    },
    async updateCategoryMedicals(selectedCategories) {
      this.loading = true;
      this.query.category_medical = selectedCategories;
      this.search();
    },
    async updateAnatomicalDistricts(selectedCategories) {
      this.loading = true;
      this.query.anatomical_district = selectedCategories;
      this.search();
    },
    mappingOriginalArray(originalArray) {
      return originalArray.map((item) => item.id);
    },
    async loadAllActivity() {
      this.loading = true;
      this.allcases = true;
      await httpauth
        .get("/casi-clinici/all")
        .then((response) => {
          var data = response.data.data;

          this.activities = data.map((oggetto) => {
            const companyId = oggetto.company_id;
            const classe =
              companyId === null
                ? "entry entry-list mb-2 mb-md-3 p-2"
                : "entry entry-list mb-2 mb-md-3 bg-light border border-2  border-danger rounded p-2";
            return { ...oggetto, class: classe };
          });

          for (var i = 1; i < response.data.meta.last_page; i++)
          {
            this.pages.push(i);
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async loadActivity() {
      this.loading = true;
      this.allcases = false;
      await httpauth
        .get("/casi-clinici/list/15")
        .then((response) => {
          var data = response.data.data;

          this.activities = data.map((oggetto) => {
            const companyId = oggetto.company_id;
            const classe =
              companyId === null
                ? "entry entry-list mb-2 mb-md-3 p-2 height-article"
                : "entry entry-list mb-2 mb-md-3 bg-light border border-2  border-danger rounded p-2 height-article";
            return { ...oggetto, class: classe };
          });

          for (var i = 1; i < response.data.meta.last_page; i++)
          {
            this.pages.push(i);
          }

          this.loading = false;

          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          console.log(error);
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedicals = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistricts = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  beforeMount() {
    let successMessage = localStorage.getItem("messageSuccessClinicalCase");
    if (successMessage)
    {
      const $toast = useToast();
      $toast.open({
        message: successMessage,
        type: "info",
        position: "top-right",
        // all of other options may go here
      });
      localStorage.removeItem("messageSuccessClinicalCase");
    }

    let errorMessage = localStorage.getItem("messageErrorClinicalCase");
    if (errorMessage)
    {
      const $toast = useToast();
      $toast.open({
        message: errorMessage,
        type: "info",
        position: "top-right",
        // all of other options may go here
      });
      localStorage.removeItem("messageErrorClinicalCase");
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.size > 0)
    {
      this.query.patologies =
        urlParams.getAll("patologies").length > 0
          ? urlParams.getAll("patologies")
          : [];
      this.query.category_medical =
        urlParams.getAll("category_medical").length > 0
          ? urlParams.getAll("category_medical")
          : [];
      this.query.anatomical_district =
        urlParams.getAll("anatomical_district").length > 0
          ? urlParams.getAll("anatomical_district")
          : [];
      this.query.search =
        urlParams.get("text") !== "" ? urlParams.get("text") : "";

      this.search();
    } else
    {
      this.loadActivity();
    }

    this.fetchCategoryMedical();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
};
</script>
<style scoped>
.border-2 {
  border: 3.5px solid red !important;
}

.height-article {
  height: 263px;
}

@media screen and (max-width: 576px) {
  .height-article {
    height: 450px;
  }
}
</style>